import { render, staticRenderFns } from "./ChessRegular.vue?vue&type=template&id=a864871a&scoped=true&"
import script from "./ChessRegular.vue?vue&type=script&lang=js&"
export * from "./ChessRegular.vue?vue&type=script&lang=js&"
import style0 from "./ChessRegular.vue?vue&type=style&index=0&id=a864871a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a864871a",
  null
  
)

export default component.exports